import React, { useContext, useState } from 'react';
import { useNavigate } from 'react-router-dom';

import { checkEmail } from './AdminClient';

import { CurrentUserContext } from 'Components/Participant/Auth/RequiresCurrentUserContext';

import LabelledInput from 'Components/Form/LabelledInput';
import Error from 'Components/Form/Error';

function CheckEmail ()
{
    const { currentUser } = useContext ( CurrentUserContext );

    const [ email, setEmail ] = useState ( null );
    const [ response, setResponse ] = useState ( null );

    const [ isSubmitting, setIsSubmitting ] = useState ( false );
    const [ error, setError ] = useState ( { isError: false, message: null } );

    const navigate = useNavigate ();
    
    const doSubmit = async () =>
    {
        if ( isSubmitting === false && email !== null && email.length > 0 )
        {
            setIsSubmitting ( true );

            checkEmail ( currentUser, email )
                .then ( response => {
                    setIsSubmitting ( false );
                    setResponse ( response.data );
                    setError ( { isError: false, message: null } )
                } )
                .catch ( error => {
                    setIsSubmitting ( false );
                    setError ( { isError: true, message: error?.message ? error.message : JSON.stringify ( error ) } )
                } );
        }
    }

    return <>
                <h1>Check Participant Email</h1>
                { error.isError && <Error message={error.message} /> }
                <LabelledInput label="Enter the email to check" id="check-email" value={email} onChange={ ( newValue ) => setEmail ( newValue ) } editable={true} />
                { response && <>
                    <div className="flex flex-row items-center gap-8">
                        <div>
                            <p>Email submitted: { response.emailExists ? "Yes" : "No" }</p>
                            <p>Participant registered: { response.isRegistered ? "Yes" : "No" }</p>
                        </div>
                    </div>
                    </> }
                <div className="flex flex-row gap-4">
                    <button onClick={ () => doSubmit () }>Check</button>
                    <button onClick={ () => navigate ( "/admin" ) }>Back</button>
                </div>
            </>
}

export default CheckEmail;